import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonSend: React.FC<MprcButtonProps> = ({ text, title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonSend.text;
    const lTitle = title || theme.buttons.ButtonSend.title;

    return (
        <MprcButton
            {...rest}
            title={lTitle}
            text={lText}
        />
    );
};
